export default __webpack_public_path__ + "static/media/proveedor.451ab8dc.jpg";